import React from 'react';
import PropTypes from 'prop-types';
import Component from '../component';
import classNames from 'classnames';
import './index.css';

export default class Transition extends Component {
  static get propTypes() {
    return {
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      isVisible: PropTypes.bool.isRequired,
      onHide: PropTypes.func.isRequired,
      closeAfter: PropTypes.bool,
      onShow: PropTypes.func
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      x: 0,
      y: 0,
      scrollY: 0,
      bodyOverflowHidden: this.props.isVisible,
      closing: false,
      loading: false,
      hiding: false,
      displayContent: false,
      hidingOverlay: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.x !== this.state.x) {
      this.setState({ x: nextProps.x });
    }
    if (nextProps.y !== this.state.y) {
      this.setState({ y: nextProps.y });
    }
    if (nextProps.scrollY !== this.state.scrollY) {
      this.setState({ scrollY: nextProps.scrollY });
    }
    if (nextProps.isVisible === true) {
      this.setState({ loading: true, bodyOverflowHidden: true });
    }
  }

  close() {
    this.setState({ bodyOverflowHidden: false, closing: true, hidingOverlay: true });
  }

  removeClosingClass(e) {
    if (e.propertyName === 'transform' && !this.state.bodyOverflowHidden) {
      if (!this.state.closing) {
        this.setState({ hiding: false, hidingOverlay: false });
        this.props.onHide();
      } else {
        this.setState({ displayContent: false, closing: false, hiding: true });
      }
    }
  }

  setStartPos(x, y) {
    return !x || !y ? null : { left: `${x}px`, top: `${y}px` };
  }

  triggerTransition(e) {
    if (e.propertyName === 'transform' && this.state.loading) {
      this.setState({ displayContent: true, loading: false });
      if (this.props.onShow) this.props.onShow();
      if (this.props.closeAfter) setTimeout(this.close, 200);
    }
  }

  render() {
    return (
      <div
        className={ classNames('transition', { loaded: this.state.displayContent }) }
        onTransitionEnd={ !this.state.hidingOverlay ? this.triggerTransition : this.removeClosingClass }
        onClick={ this.close }
      >
        { !this.state.bodyOverflowHidden
          ? null
          : <style dangerouslySetInnerHTML={{ __html: `
              body {
                overflow: hidden;
              }`
          }}/>
        }
        <div className={ classNames('loading', {
          active: this.state.loading,
          closing: this.state.closing,
          hiding: this.state.hiding
        }) } style={ this.setStartPos(this.state.x, this.state.y) } />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/transition/index.jsx